import type { ResetTaskRequest, ResetTaskResponse } from '../types';

/**
 * 重置任务API接口
 * @description 用于重置查新任务的API接口定义
 */
export const ResetTaskApi = Symbol.for('ResetTaskApi');

/**
 * 重置任务API接口
 */
export interface ResetTaskApi {
    /**
     * 重置任务
     * @param data 重置任务请求参数
     * @returns 重置任务的响应结果
     * @description 重置指定的查新任务，清除任务状态和相关数据
     */
    resetTask(data: ResetTaskRequest): Promise<ResetTaskResponse>;
}
